import CarWashService from "../../../../services/CarWashService";
import UserService from "../../../../services/UserService";
import M from "materialize-css";
import Messages from "../../../../utils/messages";
import Modal from "@/components/Modal";
export default {
  name: "EditCarWash",
  data: () => ({
    carWashId: null,
    activeTab: 1,
    tabInstance: {},
    carWash: {
      headerData: {
        address: null,
        contactPerson: null,
        crdate: null,
        enabled: null,
        id: null,
        name: null,
        phoneNumber: null,
        taxCode: null,
        washLimitPerCar: null,
      },
    },
    headerEditMode: false,

    userList: [],
    roleList: [],
    limitList: [],
    newUserModalData: {
      Show: false,
      UserName: null,
      RoleID: 0,
      Buttons: [],
    },

    LimitsAllowedProductList: [],
    LimitUpdateShowMainMode: false,
    LimitUpdateModalData: {
      Show: false,
      Buttons: [],
      ID: 0,
      ProductID: 0,
      LimitTypeID: 0,
      isMain: false,
      LimitAmount: 0,
    },
  }),
  components: { Modal },
  mounted() {
    this.carWashId = this.$router.currentRoute.params.carwashid;
    this.LimitUpdateShowMainMode = this.carWashId == 1;
    this.GetCarWash();
    this.GetAllowedProductList();
    this.GetRoleList();
    this.GetLimitList();
    this.InitTabs(null);
  },
  methods: {
    InitTabs(tabindex) {
      if (!tabindex) {
        this.tabInstance = M.Tabs.init(this.$refs.tabs, {});
      }
    },
    GetRoleList() {
      UserService.GetRoleList().then((res) => {
        this.roleList = res.roleList;
      });
    },
    GetLimitList() {
      CarWashService.GetLimitList().then((res) => {
        this.limitList = res;
      });
    },
    GetAllowedProductList() {
      CarWashService.GetAllowedProductList().then((res) => {
        this.LimitsAllowedProductList = res.productList;
      });
    },
    GetCarWash() {
      CarWashService.GetCarWash(this.carWashId).then((res) => {
        this.carWash = res.carwash;
        this.$nextTick(function () {
          M.updateTextFields();
        });
        this.carWash.limitList.forEach((element) => {
          element.editMode = false;
        });
      });
    },
    HeaderSubmitheader() {
      if (this.headerEditMode) {
        CarWashService.UpdateCarWash(
          this.carWashId,
          this.carWash.headerData.name,
          this.carWash.headerData.taxCode,
          this.carWash.headerData.address,
          this.carWash.headerData.phoneNumber,
          this.carWash.headerData.contactPerson
        ).then((res) => {
          if (res.statusCode == 0) {
            this.$message(Messages["CarWashUpdateOk"]);
            this.headerEditMode = false;
            this.GetCarWash();
          } else {
            let ErrorCode = "CarWashUpdate" + res.statusDesc;
            alert(Messages[ErrorCode]);
          }
        });
      }
    },
    HeaderSetEditMode() {
      this.headerEditMode = true;
    },
    HeaderSetViewMode() {
      this.GetCarWash();
      this.headerEditMode = false;
    },

    SetRowinEditMode(limit) {
      console.log(limit);
      this.LimitUpdateModalData.ID = limit.limitID;
      this.LimitUpdateModalData.ProductID = limit.productID;
      this.LimitUpdateModalData.LimitAmount = limit.limitAmount;
      this.LimitUpdateModalData.isMain = limit.isMain;
      this.LimitUpdateModalData.Show = true;
      this.LimitUpdateModalData.Buttons = [];
      this.LimitUpdateModalData.LimitTypeID = limit.limitTypeID;

      this.LimitUpdateModalData.Buttons.push({
        name: "შენახვა",
        class: "btn indigo lighten-1",
        style: "margin-right: 4px;",
        funq: this.UpdateLimit,
      });

      this.LimitUpdateModalData.Buttons.push({
        name: "დახურვა",
        class: "btn yellow darken-1 black-text",
        funq: this.CloseUpdateLimit,
      });

      this.$nextTick(function () {
        M.FormSelect.init(this.$refs.updatelimitproduct, {});
        M.FormSelect.init(this.$refs.updatelimitismain, {});
        M.FormSelect.init(this.$refs.updatelimittype_id, {});
        M.updateTextFields();
      });
    },
    CloseUpdateLimit() {
      this.LimitUpdateModalData.ID = 0;
      this.LimitUpdateModalData.ProductID = 0;
      this.LimitUpdateModalData.LimitAmount = 0;
      this.LimitUpdateModalData.Show = false;
      this.LimitUpdateModalData.Buttons = [];
    },
    UpdateLimit() {
      if (
        !this.LimitUpdateModalData.ProductID ||
        this.LimitUpdateModalData.ProductID == 0
      ) {
        this.$message(Messages["CawWashLimitUpdateNoProduct"]);
      } else if (
        !this.LimitUpdateModalData.LimitTypeID ||
        this.LimitUpdateModalData.LimitTypeID == 0
      ) {
        this.$message(Messages["CawWashLimitUpdateNoService"]);
      } else if (!this.LimitUpdateModalData.LimitAmount) {
        this.$message(Messages["CawWashLimitUpdateNoLimit"]);
      } else {
        const isMain = this.LimitUpdateShowMainMode
          ? this.LimitUpdateModalData.isMain == "true"
          : false;

        CarWashService.UpdateLimit(
          this.LimitUpdateModalData.ID,
          this.carWashId,
          this.LimitUpdateModalData.LimitAmount,
          this.LimitUpdateModalData.ProductID,
          this.LimitUpdateModalData.LimitTypeID,
          isMain
        ).then((res) => {
          if (res.statusCode == 2) {
            this.$message(Messages["CarWashLimitUpdateMainIsExists"]);
          } else {
            this.CloseUpdateLimit();
          }
          this.GetCarWash();
        });
      }
    },
    LimitChangeStatus(status, limitid) {
      if (status) {
        if (confirm("დარწმუნებული ბრძანდებით?")) {
          CarWashService.EnableLimit(limitid).then(() => {
            this.GetCarWash();
          });
        }
      } else {
        if (confirm("დარწმუნებული ბრძანდებით?")) {
          CarWashService.DisableLimit(limitid).then(() => {
            this.GetCarWash();
          });
        }
      }
    },

    UserChangeStatus(status, id) {
      if (status) {
        if (confirm("დარწმუნებული ბრძანდებით?")) {
          CarWashService.EnableUser(id).then(() => {
            this.GetCarWash();
          });
        }
      } else {
        if (confirm("დარწმუნებული ბრძანდებით?")) {
          CarWashService.DisableUser(id).then(() => {
            this.GetCarWash();
          });
        }
      }
    },

    ResetUserPassword(id) {
      if (confirm("დარწმუნებული ბრძანდებით?")) {
        CarWashService.ResetUserPassword(id).then(() => {
          this.$message("პაროლი განახლებულია");
          this.GetCarWash();
        });
      }
    },

    RefreshUserAttampts(id) {
      if (confirm("დარწმუნებული ბრძანდებით?")) {
        CarWashService.RefreshUserAttampts(id).then(() => {
          this.$message("მცდელობები განულებულია");
          this.GetCarWash();
        });
      }
    },
    ShowNewUserModal() {
      this.newUserModalData.Show = true;
      this.newUserModalData.Buttons = [];
      this.newUserModalData.Buttons.push({
        name: "შენახვა",
        class: "btn indigo lighten-1",
        style: "margin-right: 4px;",
        funq: this.AddNewUser,
      });

      this.newUserModalData.Buttons.push({
        name: "დახურვა",
        class: "btn yellow darken-1 black-text",
        funq: this.HideNewUserModal,
      });

      this.$nextTick(function () {
        M.FormSelect.init(this.$refs.newUserRole, {});
        M.updateTextFields();
      });
    },
    HideNewUserModal() {
      this.newUserModalData.Show = false;
      this.newUserModalData.UserName = null;
      this.newUserModalData.RoleID = 0;
      this.newUserModalData.Buttons = [];
    },
    AddNewUser() {
      let pat = /^[a-zA-Z0-9]+$/;

      if (
        !this.newUserModalData.UserName ||
        !pat.test(this.newUserModalData.UserName)
      ) {
        this.$error(Messages["CawWashAddUserCorrectUserName"]);
      } else if (this.newUserModalData.RoleID == 0) {
        this.$error(Messages["CawWashAddUserNoRole"]);
      } else {
        CarWashService.AddUser(
          this.newUserModalData.UserName,
          this.carWashId,
          this.newUserModalData.RoleID
        ).then(() => {
          this.GetCarWash();
          this.HideNewUserModal();
        });
      }
    },
  },
};
